import setTriggerPercentsFn from "../../store/utils/trigger/set-trigger-percents-fn";
import setTriggerRefs from "../../store/utils/trigger/set-trigger-refs";

/**
 * Process storage trigger parameters
 * @param {MainClassProps} main
 */
const processStorageParameters = (main) => {
  const triggers = /** @type {Array<TriggerProps>} */ (
    main.storage.get("parameters") || []
  );

  for (const trigger of triggers) {
    const parameters =
      /** @type {TriggerParametersProps} */ (trigger.get("parameters")) || [];

    for (const [name, original] of parameters) {
      const values = /** @type {DefaultTriggerParameterMapProps} */ (
        /** @type {unknown} */ (original)
      );

      const resolutions = /** @type {ResolutionProps} */ (
        /** @type {unknown} */ (values.get("resolutions"))
      );

      const value = resolutions.get("current");

      trigger.set(`p_${name}`, value);
    }

    setTriggerRefs(trigger);
    setTriggerPercentsFn(trigger);
  }
};

export default processStorageParameters;
